export default __webpack_public_path__ + "static/media/QUEENIE.e45c48ed.jpg";